import { useEffect, useRef, useState } from "react";
import VideoItem from "./VideoItem";


const VideoGrid = ({ videos = [] }) => {
  const safeVideos = Array.isArray(videos) ? videos : [];
  const videoRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const setVideoRef = (index, el) => {
    videoRefs.current[index] = el;
  };

  useEffect(() => {
    if (videoRefs.current[0]) {
      const firstVideo = videoRefs.current[0];
      if (firstVideo.readyState >= 2) {
        firstVideo.play().catch(() => { });
      } else {
        firstVideo.oncanplay = () => {
          firstVideo.play().catch(() => { });
          firstVideo.oncanplay = null;
        };
      }
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        let firstVisibleIndex = null;
        entries.forEach((entry) => {
          const index = parseInt(entry.target.dataset.index);
          if (entry.isIntersecting && firstVisibleIndex === null) {
            firstVisibleIndex = index;
          }
        });
        if (firstVisibleIndex !== null) {
          setActiveIndex(firstVisibleIndex);
        }
      },
      { threshold: 1 }
    );

    videoRefs.current.forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      observer.disconnect();
    };
  }, [safeVideos]);

  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === activeIndex) {
          if (video.readyState >= 2) {
            video.play().catch(() => { });
          } else {
            video.oncanplay = () => {
              video.play().catch(() => { });
              video.oncanplay = null;
            };
          }
        } else {
          video.pause();
        }
      }
    });
  }, [activeIndex]);

  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {safeVideos.slice(0, 4).map((video, index) => (
        <VideoItem
          key={video.id || index}
          video={video}
          index={index}
          isActive={index === activeIndex}
          onMouseEnter={handleMouseEnter}
          setVideoRef={setVideoRef}
        />
      ))}
    </div>
  );
};

export default VideoGrid;